import {computed, inject, signal, effect, Directive, OnInit} from '@angular/core';
import {ProjectStepStateService} from '../project-step-state.service';
import {ProjectDataService} from '../../../../shared/services/project-data.service';
import {TranslocoService} from '@jsverse/transloco';
import {UserContractService} from '../../../../shared/services/user-contract.service';
import {ProjectStepComponentInterface} from './project-base-step.component';
import {ToastService} from '@frontend/toast';

@Directive()
export abstract class ProjectStepBaseReactive implements ProjectStepComponentInterface, OnInit {
  protected readonly stepState = inject(ProjectStepStateService);
  protected readonly projectDataService = inject(ProjectDataService);
  protected readonly translocoService = inject(TranslocoService);
  protected readonly userContractService = inject(UserContractService);
  protected readonly toastService = inject(ToastService);

  protected readonly isLoadingState = signal(true);
  protected readonly projectId = signal<number | undefined>(undefined);

  readonly activeStep = computed(() => this.stepState.activeStep());
  readonly chapterId = computed(() => this.activeStep()?.chapterId);
  readonly stepId = computed(() => this.activeStep()?.stepId);

  readonly isCurrentStepLocked = computed(() => {
    const cId = this.chapterId();
    const sId = this.stepId();
    return cId !== undefined && sId !== undefined ? this.stepState.isStepLocked(cId, sId) : false;
  });

  readonly hasActiveContract = computed(() => {
    return this.userContractService.hasActiveContract() ?? true;
  });

  protected readonly isButtonDisabled = computed(() => {
    return this.isCurrentStepLocked() || !this.hasActiveContract();
  });

  constructor() {
    this.userContractService.fetchContractStatus();

    effect(() => {
      const id = this.projectDataService.getProjectId();

      if (id != null) {
        this.projectId.set(id);
        this.isLoadingState.set(false);
      } else {
        console.error('CRITICAL: Project ID could not be resolved in ProjectStepReactiveBase.');
      }
    });
  }

  ngOnInit(): void {
    // nothing to do here, is just to calm down the ChapterConfig
    // This statement prevents 'nx lint --fix' from deleting the method
    void this.projectId;
  }
}
